import Breadcrumb from "../../components/common/Breadcrumb";
import useBWKLSchedule from "./hooks/useBWKLSchedule";
import PointsTable from "./modules/PointsTable";
import stylesgfi from "./NationalSchoolGames.module.css";

export default function BiharWomenKabaddiPointsTableE2() {
  const [points] = useBWKLSchedule({ endpoint: "/data/BWKLE2Points.json" });
  return (
    <>
      <Breadcrumb
        pageName={BiharWomenKabaddiPointsTableE2}
        pageTitle={"BiharWomenKabaddiPointsTableE2"}
        img_url={"/img/BWKLE2-Desktop.jpeg"}
        mobile_banner="/img/BWKLE2-Mobile.jpeg"
      />
      <div>
        <h1 className={`${stylesgfi.title}`}>
          द्वितीय बिहार महिला कबड्डी लीग 2026 अंक तालिका
        </h1>
      </div>
      <div className="container">
        {/* table with points table data,
        table data contain team (logo+team), played, won, loss, tie, S.D, points */}
        <PointsTable points={points} />
      </div>
    </>
  );
}
